<template>
  <b-card>
    <!-- form -->
    <b-form>
      <b-row>
        <!-- new password -->
        <b-col md="6">
          <b-form-group
            label-for="account-new-password"
            label="Contraseña Nueva"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="account-new-password"
                v-model="newPasswordValue"
                :type="passwordFieldTypeNew"
                :state="isValidPassword"
                name="new-password"
                placeholder="Nueva Contraseña"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconNew"
                  class="cursor-pointer"
                  @click="togglePasswordNew"
                />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <!--/ new password -->

        <!-- retype password -->
        <b-col md="6">
          <b-form-group
            label-for="account-retype-new-password"
            label="Repita la nueva contraseña"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="account-retype-new-password"
                v-model="RetypePassword"
                :type="passwordFieldTypeRetype"
                name="retype-password"
                :state="isValidPassword"
                placeholder="Nueva Contraseña"
                @blur="confirmPassword"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconRetype"
                  class="cursor-pointer"
                  @click="togglePasswordRetype"
                />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <!--/ retype password -->

        <!-- buttons -->
        <b-col cols="12">
          <b-button
            v-if="!loading"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            block
            :disabled="btnPassword"
            @click="updatePassword"
          >
            <feather-icon
              icon="SaveIcon"
              class="mr-25"
            />
            Actualizar
          </b-button>
          <b-button
            v-else
            block
            disabled
            variant="primary"
          >
            <b-spinner small />
            Procesando...
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import {
  BButton,
  BCard,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BRow,
  BSpinner,
} from "bootstrap-vue"
import Ripple from "vue-ripple-directive"

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BSpinner,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      passwordValueOld: "",
      newPasswordValue: "",
      RetypePassword: "",
      passwordFieldTypeOld: "password",
      passwordFieldTypeNew: "password",
      passwordFieldTypeRetype: "password",
      btnPassword: true,
      loading: false,
      isValidPassword: null,
    }
  },
  computed: {
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === "password"
        ? "EyeIcon"
        : "EyeOffIcon"
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === "password"
        ? "EyeIcon"
        : "EyeOffIcon"
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === "password"
        ? "EyeIcon"
        : "EyeOffIcon"
    },
  },
  methods: {
    togglePasswordOld() {
      this.passwordFieldTypeOld =
                this.passwordFieldTypeOld === "password" ? "text" : "password"
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew =
                this.passwordFieldTypeNew === "password" ? "text" : "password"
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype =
                this.passwordFieldTypeRetype === "password"
                  ? "text"
                  : "password"
    },
    confirmPassword() {
      if (this.newPasswordValue == this.RetypePassword) {
        this.btnPassword = false
        this.isValidPassword = true
      } else {
        this.btnPassword = true
        this.isValidPassword = false
      }
    },
    updatePassword() {
      this.loading = true
      this.$http
        .put(`/user-password/${this.userData.id}`, {
          password: this.newPasswordValue,
        })
        .then((response) => {
          this.showToast(
            "Contraseña actualizado exitosamente",
            "success",
            "CheckCircleIcon",
          )
          this.loading = false
          this.isValidPassword = null
        })
        .catch((error) => {
          this.loading = false
          this.showToast(error, "danger", "IconCancel")
        })
    },
    showToast(message, variant, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          variant,
          icon,
        },
      })
    },
  },
}
</script>
